import SEOHead from '@/components/feature/SEOHead';
import Navbar from './components/Navbar';
import HeroSearch from './components/HeroSearch';
import TruthPledge from './components/TruthPledge';
import GlobalCities from './components/GlobalCities';
import LoginSection from './components/LoginSection';
import FeaturedMembers from './components/FeaturedMembers';
import MembershipCTA from './components/MembershipCTA';
import ShopSection from './components/ShopSection';
import EducationSection from './components/EducationSection';
import SharingDonation from './components/SharingDonation';
import BigFamily from './components/BigFamily';
import HomeFAQ from './components/HomeFAQ';
import Footer from './components/Footer';

const HOME_JSONLD = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '富缘佳旺 FortuneMatch',
    url: import.meta.env.VITE_SITE_URL || 'https://example.com',
    description: '富缘佳旺FortuneMatch是中国领先的婚恋交友平台，提供视频认证、学历优先匹配、情感教育课程。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '富缘佳旺 FortuneMatch',
    url: import.meta.env.VITE_SITE_URL || 'https://example.com',
    logo: 'https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/b31ed3570265bb91107b593ba40da4ad.jpeg',
    description: '中国领先的婚恋交友平台，真实认证会员600万+，全球800城市覆盖，视频交友安全可靠。',
    sameAs: [],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Chinese', 'English'],
    },
  },
];

export default function Home() {
  return (
    <div className="min-h-screen pb-16 md:pb-0">
      <SEOHead
        title="富缘佳旺婚恋网站 FortuneMatch - 真实认证视频交友 教育为本缘定终身"
        description="富缘佳旺FortuneMatch是中国领先的婚恋交友平台，提供视频认证、学历优先匹配、情感教育课程。真实认证会员600万+，视频交友安全可靠，教育为本助您缘定终身。"
        keywords="婚恋网站,视频交友,富缘佳旺,FortuneMatch,学历认证,情感教育,华人婚恋"
        canonical="/"
        jsonLd={HOME_JSONLD}
      />
      <Navbar />
      <main>
        {/* 富缘佳旺 Brand Hero + Search */}
        <HeroSearch />
        {/* 真实承诺 · 四重认证 */}
        <TruthPledge />
        {/* 全球12城市华人婚恋 */}
        <GlobalCities />
        {/* 会员登录入口 */}
        <LoginSection />
        {/* 精选推荐 */}
        <FeaturedMembers />
        {/* 会员方案 */}
        <MembershipCTA />
        {/* 精选好物 · 本地直邮 */}
        <ShopSection />
        {/* 情感与婚姻教育 */}
        <EducationSection />
        {/* 生活分享与爱心捐赠 */}
        <SharingDonation />
        {/* 常见问题 */}
        <HomeFAQ />
        {/* 大家庭社区 */}
        <BigFamily />
      </main>
      <Footer />
    </div>
  );
}
